import { type QueryHookOptions, useQuery } from "@apollo/client";
import { ChildrenContentsQuery } from "../graphql/queries";
import type {
  ChildrenContentsQueryType,
  ChildrenContentsQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useChildrenContentsQuery = (
  options?: QueryHookOptions<
    ChildrenContentsQueryType,
    ChildrenContentsQueryVariablesType
  >
) => {
  return useQuery<
    ChildrenContentsQueryType,
    ChildrenContentsQueryVariablesType
  >(ChildrenContentsQuery, options);
};
